import React, { useEffect, useState } from 'react';
import AppLayout from '../components/AppLayout';
import SocialConnectPanel from '../components/SocialConnectPanel';
import { useAuth } from '../contexts/AuthContext';
import { useResponsive } from '../hooks/useResponsive';
import { familyAPI } from '../services/api';

const Connections: React.FC = () => {
  const { user, sessionToken } = useAuth();
  const { isMobile } = useResponsive();
  const [athleteId, setAthleteId] = useState<string | null>(null);
  const [loadingAthlete, setLoadingAthlete] = useState(true);

  const isStaff = user?.user_type === 'staff';

  // Resolve the athlete id the same way Analytics / Messages do — through
  // familyAPI.getMyAthletes so guardians get their linked athlete via
  // guardian_athlete_relationships. Staff users have no athlete profile
  // here; SocialConnectPanel will render the "add your athlete" CTA for
  // them (acceptable since this page isn't really their workflow).
  useEffect(() => {
    if (!sessionToken) { setLoadingAthlete(false); return; }
    let cancelled = false;
    (async () => {
      try {
        const my = await familyAPI.getMyAthletes(sessionToken);
        const first = my.athletes?.[0];
        if (!cancelled && first?.id) setAthleteId(first.id);
      } catch (err) {
        console.error('Connections: failed to load athleteId', err);
      } finally {
        if (!cancelled) setLoadingAthlete(false);
      }
    })();
    return () => { cancelled = true; };
  }, [sessionToken]);

  return (
    <AppLayout>
      <div
        style={{
          padding: isMobile ? '16px' : '32px',
          maxWidth: '880px',
          margin: '0 auto',
          fontFamily: 'Manrope, sans-serif',
        }}
      >
        <div style={{ marginBottom: 16 }}>
          <h2 style={{ margin: '0 0 4px 0', fontSize: 22, fontWeight: 700, color: '#151133' }}>
            Your connections
          </h2>
          <p style={{ margin: 0, fontSize: 14, color: '#64748b' }}>
            Connect Gmail and X so we can track coach outreach. Disconnect anytime from the same row.
          </p>
        </div>

        {loadingAthlete && !isStaff ? (
          <div style={{ padding: '40px', textAlign: 'center', color: '#64748b', fontSize: 14 }}>
            Loading your accounts…
          </div>
        ) : (
          <SocialConnectPanel
            athleteId={athleteId}
            hideYouTube={isStaff}
            title="Your accounts"
          />
        )}
      </div>
    </AppLayout>
  );
};

export default Connections;
